/*
Sohel 01/11/2023 2698947782 Added Delete Popup
*/
import React from 'react';
import {Button, Typography} from '@material-ui/core';
import reusableInputStyles from '../../../../../components/InputStyles';
function DataExistsPopup({setISDataExists, deleteData}) {
  const classes = reusableInputStyles();
  return (
    <div>
      <div className={classes.dialoguecardStyles}>
        <div className="text-center my-3">
          <Typography variant="h4">
            {' '}
            Unable to delete {deleteData?.repositoryName} data already exists
          </Typography>
        </div>
        <div className="button-table-spacing-mb">
          <Button
            type="button"
            variant="outlined"
            className={`ml-1 reset-btn`}
            onClick={() => setISDataExists(false)}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
export default DataExistsPopup;
